import styled, { css } from 'styled-components';
import { helpTokens } from '../../tokens/components/Help/tokens';
import { tooltipTokens } from '../../tokens/components/Tooltip/tokens';
import { buttonTokens } from '../../tokens/components/Button/tokens';
import { StyledButton } from '../Button/Button';
import { resetBrowserButton } from '../Button/styles';
import { StyledAnchor } from '../Anchor/Anchor';

// Creates a hitting area greater than the original element
// without affecting its resulting box dimentions
const interactionArea = css`
  padding: ${helpTokens.SpacingBaseDefault};
  margin: calc(${helpTokens.SpacingBaseDefault} * -1);
`;

export const HelpWrapper = styled.div`
  ${({ theme }) =>
    theme.type === 'tooltip' &&
    css`
      display: inline-block;
      line-height: 1;
      margin: 0 ${helpTokens.SpacingBaseDefault};
      text-align: left;
    `}

  ${({ theme }) =>
    theme.type !== 'tooltip' &&
    css`
      font-size: ${helpTokens.FontSizeBaseDefault};
    `}
`;

export const FieldHelpText = styled.p`
  color: ${helpTokens.FontColorBaseDefault};
  font-size: ${helpTokens.FontSizeBaseDefault};
  font-weight: ${helpTokens.FontWeightBaseDefault};
  line-height: ${helpTokens.FontLeadingBaseDefault};
`;

export const HelpContent = styled.div`
  ${({ theme }) =>
    theme.type === 'field' &&
    !theme.fieldStacked &&
    css`
      margin-bottom: ${helpTokens.SpacingFieldDefault};
    `}

  ${({ theme }) =>
    theme.type !== 'tooltip' &&
    css`
      ${StyledAnchor} {
        font-size: ${helpTokens.FontSizeBaseDefault};
        font-weight: ${helpTokens.FontWeightBaseDefault};
      }
    `}
`;

export const HelpTrigger = styled.button`
  ${interactionArea}
  ${resetBrowserButton}

  border-radius: 50%;
  color: ${helpTokens.GraphicColorBaseDefault};
  cursor: pointer;
  display: inline;
  height: 16px;
  transition-duration: 80ms;
  transition-property: box-shadow, outline;
  transition-timing-function: ease-out;
  vertical-align: text-top;

  &:focus-visible {
    outline: 1px solid ${buttonTokens.BorderColorBaseKeyboardFocus};
    box-shadow: 0 0 0 ${buttonTokens.ShadowWidthBaseKeyboardFocus} ${buttonTokens.ShadowColorBaseKeyboardFocus};
  }
`;

export const HelpLink = styled.div`
  align-items: center;
  display: flex;

  // Allow links to wrap normally
  ${StyledButton} {
    white-space: normal;
    ${({ theme }) =>
      theme.type === 'tooltip' &&
      css`
        color: ${buttonTokens.FontColorLinkInverse};
      `}
  }
`;

export const HelpText = styled.div`
  color: ${helpTokens.FontColorBaseDefault};

  & + ${HelpLink} {
    margin-top: 4px;
  }

  ${({ theme }) =>
    theme.type === 'tooltip' &&
    css`
      color: ${tooltipTokens.ContainerFontColorBaseDefault};
      font-weight: ${helpTokens.FontWeightBaseDefault};
      white-space: normal;
    `}
`;

export const HelpIcon = styled.div`
  color: ${helpTokens.GraphicColorBaseDefault};
  display: inline-flex;
  margin-right: 8px;

  ${({ theme }) =>
    theme.type !== 'tooltip' &&
    css`
      margin-right: 4px;
    `}
`;
